import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { paymentsApi, type PaymentListParams } from '@/api/payments';

export function usePayments(params: PaymentListParams = {}) {
  return useQuery({
    queryKey: ['payments', params],
    queryFn: () => paymentsApi.list(params),
  });
}

export function usePayment(id: number | null) {
  return useQuery({
    queryKey: ['payment', id],
    queryFn: () => paymentsApi.get(id as number),
    enabled: id !== null,
  });
}

export function useUploadPaymentProof(id: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (form: FormData) => paymentsApi.uploadProof(id, form),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['payment', id] });
      void qc.invalidateQueries({ queryKey: ['payments'] });
    },
  });
}

export function useInitiateKaspi() {
  return useMutation({
    mutationFn: (id: number) => paymentsApi.initiateKaspi(id),
  });
}
